// The header's "Other Messages" button for a Sales Hold (2026-10-07). Its list
// comes from GET /:id/order-summary/other-conversations, fetched after the
// header's own order-summary so the header never waits on it. While that
// request runs the button shows its own small loading state; once it lands,
// the button shows when the list has anything in it. Every other conversation
// keeps GET /:id's otherBuyerConversations, unchanged.

// { list, loading } for the header: the Sales Hold list once fetched (empty
// until then), or the conversation's own list for everything else.
export function otherMessagesFor({ isSalesHold, conversationList, salesHold }) {
  if (!isSalesHold) return { list: conversationList ?? [], loading: false }
  return { list: salesHold?.list ?? [], loading: Boolean(salesHold?.loading) }
}

// What the button shows: 'loading', 'button' or 'none'.
export function otherMessagesButtonState({ list, loading }) {
  if (loading) return 'loading'
  return (list?.length ?? 0) > 0 ? 'button' : 'none'
}
